import { useState } from 'react';
import { NudosButton, NudosTextInput } from '../../../../../components/NudosComponents';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import { isValidLink } from '../../../../../utils/formValidations';
import { IlogisticServiceTrelloCardData } from '../../../../../types/services';
import { putLogisticServicePaymentLink } from '../../../../../services/services';
import './ModalAddPaymentLink.scss';

const ModalAddPaymentLinkContent = ({
  closeModalCallback,
  logisticServiceData,
  updateTrelloDataCallback
}: {
  closeModalCallback: () => void;
  logisticServiceData: IlogisticServiceTrelloCardData;
  updateTrelloDataCallback?: () => void;
}) => {
  const { id: logisticServiceId } = logisticServiceData;
  const [paymentLink, setPaymentLink] = useState<string>();
  const [loading, setLoading] = useState(false);

  const isButtonDisabled = !paymentLink || !isValidLink(paymentLink) || !logisticServiceId;
  const linkError = paymentLink && !isValidLink(paymentLink) ? 'Link inválido' : '';

  const submitModal = async () => {
    if (isButtonDisabled) return;
    setLoading(true);
    try {
      await putLogisticServicePaymentLink(logisticServiceId, { paymentLink });
      closeModalCallback();
      displaySuccessNotification({ customJSXMessage: <>Se cargó el link de pago exitosamente</> });
      updateTrelloDataCallback && updateTrelloDataCallback();
    } catch {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ModalAddPaymentLinkContent">
      <div className="paymentLinkSubtitle">Carga link de pago para el SL N°{logisticServiceId}</div>
      <div className="explanationText">
        Revisa el link de pago antes de guardar, recuerda que la empresa recibirá este link a través de un correo{' '}
      </div>
      <NudosTextInput
        componentSize="large"
        label="Link de pago"
        placeholder={'Ingresa el link de stripe'}
        isFilled={!!paymentLink}
        errorText={linkError}
        defaultValue={paymentLink}
        handleChange={setPaymentLink}
      />
      <NudosButton
        componentSize="large"
        buttonText="Guardar"
        handleClick={submitModal}
        isButtonDisabled={isButtonDisabled}
        isButtonLoading={loading}
      />
    </div>
  );
};

export default ModalAddPaymentLinkContent;
